import {
  useCreateMetaProviderMutation,
  useGetMetaProviderQuery,
  useUpdateMetaProviderMutation
} from '@features/lead-management/queries/LeadManagementQuery';

interface UseMetaProviderOptions {
  skip?: boolean;
}

const useMetaProvider = (
  organizationId: string | null,
  options: UseMetaProviderOptions = {}
) => {
  const skip = !organizationId || options.skip;

  const {
    data: providerData,
    isLoading,
    refetch
  } = useGetMetaProviderQuery(
    { organizationId: organizationId ?? '' },
    { skip }
  );

  const [createProvider, { isLoading: isCreating }] =
    useCreateMetaProviderMutation();
  const [updateProvider, { isLoading: isUpdating }] =
    useUpdateMetaProviderMutation();

  return {
    providerData,
    isLoading,
    refetch,
    createProvider,
    updateProvider,
    isCreating,
    isUpdating,
    hasProvider: !!providerData
  };
};

export default useMetaProvider;
